/* eslint-disable no-multi-spaces */
import template from './template.vue'
import Vue from 'vue'
const types = [
  '_-_',    // no navbar, no footer
  '_-S',    // no navbar, sticky footer
  '_-NS',   // no navbar, non-sticky footer
  // 'F-_',    // full navbar, no footer (unused)
  'F-S',    // full navbar, sticky footer
  'F-NS',   // full navbar, non-sticky footer
  'L-_',    // light navbar, no footer
  // 'L-S',    // light navbar, sticky footer (unused)
  'L-NS'    // light navbar, non-sticky footer
  // Note: uncomment types if the need for use will arise
]
export default types.reduce(
  (acc, type) => {
    const [navbar, footer] = type.split(/[-]/)
    return {
      ...acc,
      [type]: Vue.component(
        `Layout${type}`,
        {
          render: h => {
            return h(template, { props: { footer, navbar } })
          }
        }
      )
    }
  }, {} as Record<string, any>
)
